var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidanceExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5C12.5304 19.5 13.0391 19.7107 13.4142 20.0858C13.7893 20.4609 14 20.9696 14 21.5C14 22.0304 13.7893 22.5391 13.4142 22.9142C13.0391 23.2893 12.5304 23.5 12 23.5C11.4696 23.5 10.9609 23.2893 10.5858 22.9142C10.2107 22.5391 10 22.0304 10 21.5C10 20.9696 10.2107 20.4609 10.5858 20.0858C10.9609 19.7107 11.4696 19.5 12 19.5ZM14 16.5H10V16.371C9.99982 11.1451 9.33891 5.94013 8.033 0.88L8 0.75V0.5H16V0.75L15.967 0.879C14.6611 5.93913 14.0002 11.1441 14 16.37V16.5Z",
    stroke: "#B63940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidanceExclamationMark);
export default __webpack_public_path__ + "static/media/guidance_exclamation-mark.c0c29c5b2db2c933739077d9abb64bfd.svg";
export { ForwardRef as ReactComponent };